function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export function RemoteIcon(_0) {
    let { color = '#7B84A3' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    var _props_width, _props_width1;
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: (_props_width = props.width) !== null && _props_width !== void 0 ? _props_width : 20,
        height: (_props_width1 = props.width) !== null && _props_width1 !== void 0 ? _props_width1 : 22,
        viewBox: "0 0 18 18"
    }, props), {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10.0833 15.5C9.38889 15.5 8.79861 15.2569 8.3125 14.7708C7.82639 14.2847 7.58333 13.6944 7.58333 13C7.58333 12.3056 7.82639 11.7153 8.3125 11.2292C8.79861 10.7431 9.38889 10.5 10.0833 10.5C10.7778 10.5 11.3681 10.7431 11.8542 11.2292C12.3403 11.7153 12.5833 12.3056 12.5833 13C12.5833 13.6944 12.3403 14.2847 11.8542 14.7708C11.3681 15.2569 10.7778 15.5 10.0833 15.5ZM10.0833 13.8333C10.3194 13.8333 10.5174 13.7535 10.6771 13.5938C10.8368 13.434 10.9167 13.2361 10.9167 13C10.9167 12.7639 10.8368 12.566 10.6771 12.4062C10.5174 12.2465 10.3194 12.1667 10.0833 12.1667C9.84722 12.1667 9.64931 12.2465 9.48958 12.4062C9.32986 12.566 9.25 12.7639 9.25 13C9.25 13.2361 9.32986 13.434 9.48958 13.5938C9.64931 13.7535 9.84722 13.8333 10.0833 13.8333ZM11.75 9.66667C10.4722 9.66667 9.38889 9.22222 8.5 8.33333C7.61111 7.44444 7.16667 6.36111 7.16667 5.08333C7.16667 3.80556 7.61111 2.72222 8.5 1.83333C9.38889 0.944444 10.4722 0.5 11.75 0.5C13.0278 0.5 14.1111 0.944444 15 1.83333C15.8889 2.72222 16.3333 3.80556 16.3333 5.08333C16.3333 6.36111 15.8889 7.44444 15 8.33333C14.1111 9.22222 13.0278 9.66667 11.75 9.66667ZM11.75 8C12.5694 8 13.2604 7.71875 13.8229 7.15625C14.3854 6.59375 14.6667 5.90278 14.6667 5.08333C14.6667 4.26389 14.3854 3.57292 13.8229 3.01042C13.2604 2.44792 12.5694 2.16667 11.75 2.16667C10.9306 2.16667 10.2396 2.44792 9.67708 3.01042C9.11458 3.57292 8.83333 4.26389 8.83333 5.08333C8.83333 5.90278 9.11458 6.59375 9.67708 7.15625C10.2396 7.71875 10.9306 8 11.75 8ZM3.83333 13C2.91667 13 2.13194 12.6736 1.47917 12.0208C0.826389 11.3681 0.5 10.5833 0.5 9.66667C0.5 8.75 0.826389 7.96528 1.47917 7.3125C2.13194 6.65972 2.91667 6.33333 3.83333 6.33333C4.75 6.33333 5.53472 6.65972 6.1875 7.3125C6.84028 7.96528 7.16667 8.75 7.16667 9.66667C7.16667 10.5833 6.84028 11.3681 6.1875 12.0208C5.53472 12.6736 4.75 13 3.83333 13ZM3.83333 11.3333C4.29167 11.3333 4.68403 11.1701 5.01042 10.8438C5.33681 10.5174 5.5 10.125 5.5 9.66667C5.5 9.20833 5.33681 8.81597 5.01042 8.48958C4.68403 8.16319 4.29167 8 3.83333 8C3.375 8 2.98264 8.16319 2.65625 8.48958C2.32986 8.81597 2.16667 9.20833 2.16667 9.66667C2.16667 10.125 2.32986 10.5174 2.65625 10.8438C2.98264 11.1701 3.375 11.3333 3.83333 11.3333Z",
            fill: color
        })
    }));
}
